import locationPermissionImg from '../../../assets/location-permission.png';

const LocationPermissionSvg = ({ width = 200, height = 159 }) => (
  <img
    src={locationPermissionImg}
    alt=''
    width={width}
    height={height}
    style={{ objectFit: 'contain', display: 'block' }}
  />
);

export default LocationPermissionSvg;
